import Swal from "sweetalert2";
import i18n from "./../js/i18n";

function say(text = "", title = "", icon = null) {
  return Swal.fire({
    title,
    text,
    icon,
    showCancelButton: false,
  });
}

function ask(text = "", title = "", icon = null) {
  return Swal.fire({
    title,
    text,
    icon,
    showCancelButton: true,
    confirmButtonText: i18n.t("swal.yep"),
    cancelButtonText: i18n.t("swal.nope"),
    reverseButtons: false,
  });
}

function prompt(text = "", title = "", inputValue = "", icon = null) {
  return Swal.fire({
    title,
    text,
    icon,
    input: "text",
    inputValue,
    showCancelButton: true,
    confirmButtonText: i18n.t("swal.ok"),
    cancelButtonText: i18n.t("swal.cancell"),
    reverseButtons: false,
  });
}

function promptPassword(
  title = "Необходимо ввести ваш пароль для подтверждения"
) {
  return Swal.fire({
    title,
    input: "password",
  });
}

export { say, ask, prompt, promptPassword };
